import { useSnackbar as useNotistackSnackbar } from 'notistack';
import { INotificationService } from './INotificationService';

/**
 * Konkrete Implementierung des NotificationService mit notistack
 * Diese Klasse kapselt die UI-spezifische Logik
 */
export class SnackbarNotificationService implements INotificationService {
  constructor(
    private readonly enqueueSnackbar: ReturnType<
      typeof useNotistackSnackbar
    >['enqueueSnackbar'],
  ) {}

  showSuccess(message: string, duration = 5000): void {
    this.enqueueSnackbar(message, {
      variant: 'success',
      autoHideDuration: duration,
    });
  }

  showError(message: string, duration = 7000): void {
    this.enqueueSnackbar(message, {
      variant: 'error',
      autoHideDuration: duration,
    });
  }

  showWarning(message: string, duration = 5000): void {
    this.enqueueSnackbar(message, {
      variant: 'warning',
      autoHideDuration: duration,
    });
  }

  showInfo(message: string, duration = 5000): void {
    this.enqueueSnackbar(message, {
      variant: 'info',
      autoHideDuration: duration,
    });
  }
}

export function useSnackbarNotificationService(): SnackbarNotificationService {
  const { enqueueSnackbar } = useNotistackSnackbar();
  return new SnackbarNotificationService(enqueueSnackbar);
}
